<template>
  <b-container fluid class="buy-page">
    <b-row class="p-0 m-0 px-5">
      <!-- Header -->
      <b-col lg="12" class="m-0 p-0 py-5">
        <b-row class="m-0 p-0 align-items-center">
          <b-col lg="8">
            <div class="d-flex align-items-center">
              <div class="title-badge mr-3">
                <b-icon icon="cash-coin" font-scale="1.25"></b-icon>
              </div>
              <div>
                <h5 class="crypto-main-title mb-1">
                  Создать ордер на покупку или продажу цифровых активов
                </h5>
                <small class="header-sub">
                  Совершайте обменные операции с цифровыми активами быстро и безопасно
                </small>
              </div>
            </div>
          </b-col>

          <b-col lg="4" class="text-right pt-2 pt-lg-0"></b-col>
        </b-row>
      </b-col>

      <!-- Left: Steps -->
      <b-col lg="4">
        <div class="step-out">
          <div class="step-item" :class="{ 'step-item-active': step === 0 || step > 0 }">
            <div v-if="step == 0" class="d-inline-block step-number text-center">
              <span class="d-inline-block">1</span>
            </div>
            <div class="d-inline-block" v-if="step >= 1">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="#58BD7D" />
                <path d="M12 16L14.6667 18.6666L20 13.3333" stroke="#FCFCFD" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="d-inline-block ml-4 step-name">Выберите цифровой актив</div>
          </div>

          <div style="margin-left: 18px;">
            <div class="d-inline-block step-item-step"></div>
          </div>

          <div class="step-item" :class="{ 'step-item-active': step >= 1 && step < 3 }">
            <div class="d-inline-block" v-if="(step >= 1 && isFormComplete) || step == 3">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="#58BD7D" />
                <path d="M12 16L14.6667 18.6666L20 13.3333" stroke="#FCFCFD" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div v-else class="d-inline-block step-number text-center">
              <span class="d-inline-block">2</span>
            </div>
            <div class="d-inline-block ml-4 step-name">Заполните и отправьте заявку</div>
          </div>

          <div style="margin-left: 18px;">
            <div class="d-inline-block step-item-step"></div>
          </div>

          <div class="step-item" :class="{ 'step-item-active': step == 3 }">
            <div v-if="step < 3" class="d-inline-block step-number text-center">
              <span class="d-inline-block">3</span>
            </div>
            <div class="d-inline-block" v-else>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="#58BD7D" />
                <path d="M12 16L14.6667 18.6666L20 13.3333" stroke="#FCFCFD" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="d-inline-block ml-4 step-name">Ожидайте подтверждения</div>
          </div>

        </div>
      </b-col>

      <!-- Right: Step 0 - coin list -->
      <b-col lg="8" class="m-0 p-4 right-out" v-if="step == 0">
        <b-row class="m-0 p-0">
          <b-col lg="12" class="pb-3 d-flex justify-content-between align-items-center">
            <h5 class="crypto-action-title mb-0">Выберите криптовалюту</h5>

            <div class="coin-search">
              <b-input-group size="sm" class="coin-search-inp">
                <b-input-group-prepend>
                  <b-input-group-text class="bg-transparent border-0">
                    <b-icon icon="search"></b-icon>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="coinFilter" placeholder="Поиск по монетам..." class="bg-transparent border-0" />
                <b-input-group-append>
                  <b-button size="sm" variant="link" class="text-muted" :disabled="!coinFilter" @click="coinFilter = ''">
                    <b-icon icon="x"></b-icon>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
        </b-row>

        <b-row class="m-0 p-0">
          <b-col lg="1"><span class="list-header-text">#</span></b-col>
          <b-col lg="5"><span class="list-header-text">Имя</span></b-col>
          <b-col lg="3"><span class="list-header-text">Цена</span></b-col>
          <b-col lg="3"><span class="list-header-text">Динамика изменения стоимости за 24 часа</span></b-col>
        </b-row>

        <div class="list-sep my-3"></div>

        <!-- Спиннер пока грузится список активов. -->
        <div v-if="coinsLoading" class="coins-loading">
          <b-spinner class="coins-spinner" />
        </div>
        <div v-else-if="!filteredCoins.length" class="coins-loading">
          <span class="coins-loading-text">Активы не найдены</span>
        </div>

        <template v-else>
          <b-row class="m-0 p-0 mb-3 crypto-row pt-3 pb-2" v-for="(c, ci) in filteredCoins" :key="ci" @click="buyCrypto(1, c)">
            <b-col lg="1"><span class="list-text-number">{{ ci + 1 }}</span></b-col>
            <b-col lg="5">
              <div class="d-flex align-items-center">
                <div class="coin-ic mr-3">
                  <img :src="c.image" width="32" height="32" class="rounded"
                       referrerpolicy="no-referrer" @error="onCoinImgError" />
                </div>
                <div class="min-w-0">
                  <div class="d-flex align-items-center">
                    <span class="list-text-crypto mr-2 text-truncate">{{ c.id }}</span>
                    <span class="list-text-code text-uppercase">{{ c.symbol }}</span>
                  </div>
                  <small class="text-muted">Рыночная капитализация: #{{ c.market_cap_rank || "-" }}</small>
                </div>
              </div>
            </b-col>
            <b-col lg="3">
              <span class="list-text-price">${{ c.current_price | money }}</span>
            </b-col>
            <b-col lg="3">
              <span class="list-text-percentage" :class="{ 'pct-up': (c.price_change_percentage_24h || 0) >= 0, 'pct-down': (c.price_change_percentage_24h || 0) < 0 }">
                {{ formatChangePct(c.price_change_percentage_24h) }}
              </span>
            </b-col>
          </b-row>
        </template>
      </b-col>

      <!-- Right: Success -->
      <b-col lg="8" class="m-0 p-4 right-out" v-if="step == 3">
        <b-row class="p-0 m-0">
          <b-col lg="12" class="m-0 p-0 pt-1 text-left" @click="buyCrypto(0)">
            <svg width="24" style="cursor: pointer;" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.90906 7.76521C9.50324 7.3906 8.87058 7.4159 8.49597 7.82172L5.2652 11.3217C4.9116 11.7047 4.9116 12.2952 5.26519 12.6782L8.49597 16.1783C8.87057 16.5841 9.50323 16.6094 9.90905 16.2348C10.3149 15.8602 10.3402 15.2276 9.96558 14.8217L8.28397 13L18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11L8.284 11L9.96557 9.17829C10.3402 8.77247 10.3149 8.13981 9.90906 7.76521Z"
                fill="#777E91"
              />
            </svg>
          </b-col>
        </b-row>

        <div class="success-wrap text-center mt-2">
          <div class="success-ic mb-3">
            <b-icon icon="check2-circle" font-scale="2"></b-icon>
          </div>
          <h5 class="crypto-action-title mb-2">Операция прошла успешно</h5>
          <div class="text-muted mb-4">Проверьте брокерскую книгу для деталей</div>
        </div>

        <BankInfo v-if="buyForm.exType == 'BUY'" :items="items" />
      </b-col>

      <!-- Right: Step 1/2 - form -->
      <b-col lg="8" class="m-0 p-4 right-out" v-if="step >= 1 && step < 3">
        <b-row class="p-0 m-0">
          <b-col lg="12" class="m-0 p-0 pt-1 text-left" @click="buyCrypto(0)">
            <svg width="24" style="cursor: pointer;" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.90906 7.76521C9.50324 7.3906 8.87058 7.4159 8.49597 7.82172L5.2652 11.3217C4.9116 11.7047 4.9116 12.2952 5.26519 12.6782L8.49597 16.1783C8.87057 16.5841 9.50323 16.6094 9.90905 16.2348C10.3149 15.8602 10.3402 15.2276 9.96558 14.8217L8.28397 13L18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11L8.284 11L9.96557 9.17829C10.3402 8.77247 10.3149 8.13981 9.90906 7.76521Z"
                fill="#777E91"
              />
            </svg>
          </b-col>
        </b-row>

        <b-row class="m-0 p-0">
          <b-col lg="12">
            <h5 class="crypto-action-title d-inline-block w-100 text-center mb-4">
              {{ buyForm.exType === "SELL" ? "Заполните заявку на продажу цифровых активов" : "Заполните заявку на покупку цифровых активов" }}
            </h5>
          </b-col>
        </b-row>

        <!-- Selected coin card -->
        <div class="coin-card mb-4">
          <b-row class="m-0 p-0 align-items-center">
            <b-col lg="8" class="p-0">
              <div class="d-flex align-items-center">
                <div class="coin-ic mr-3">
                  <img :src="selectedCoin.image" width="38" height="38" class="rounded"
                       referrerpolicy="no-referrer" @error="onCoinImgError" />
                </div>
                <div class="min-w-0">
                  <div class="d-flex align-items-center">
                    <span class="list-text-crypto mr-2 text-truncate">{{ selectedCoin.id }}</span>
                    <span class="list-text-code text-uppercase">{{ selectedCoin.symbol }}</span>
                  </div>
                  <small class="text-muted">
                    Предварительный курс: 1 {{ (selectedCoin.symbol || '').toUpperCase() }} ≈ ${{ selectedCoin.current_price | money }} USD
                  </small>
                </div>
              </div>
            </b-col>
            <b-col lg="4" class="p-0 text-right">
              <span class="list-text-percentage" :class="{ 'pct-up': (selectedCoin.price_change_percentage_24h || 0) >= 0, 'pct-down': (selectedCoin.price_change_percentage_24h || 0) < 0 }">
                Динамика изменения стоимости за 24 часа: {{ formatChangePct(selectedCoin.price_change_percentage_24h) }}
              </span>
            </b-col>
          </b-row>
        </div>

        <!-- BUY / SELL toggle: клиент выбирает направление уже после
             выбора актива. URL синхронизируется (router.replace, чтобы
             back button не сваливал в промежуточное состояние). Сброс
             draft'а и амаунт'а — 100 в BUY = «100 USD», в SELL = «100
             coin», разные суммы, безопаснее очистить. -->
        <div class="direction-switch mb-3">
          <button
            type="button"
            class="dir-chip"
            :class="{ 'dir-chip-active-buy': buyForm.exType === 'BUY' }"
            @click="setExType('BUY')"
          >Купить</button>
          <button
            type="button"
            class="dir-chip"
            :class="{ 'dir-chip-active-sell': buyForm.exType === 'SELL' }"
            @click="setExType('SELL')"
          >Продать</button>
        </div>

        <!-- 🚨 Limit banner -->
        <transition name="fade">
          <div v-if="isOverMonthlyLimit" class="limit-banner mb-3">
            <b-icon icon="exclamation-triangle" class="mr-2"></b-icon>
            Сумма ордера превышает доступный лимит. Доступно&nbsp;<strong>{{ limitRemaining | money(2) }} USD</strong>&nbsp;из&nbsp;<strong>{{ limitInvestment | money(2) }} USD</strong>&nbsp;на этот месяц. Уменьшите сумму и попробуйте снова.
          </div>
        </transition>

        <!-- Form inputs -->
        <b-row class="m-0 p-0">
          <!-- Amount -->
          <b-col lg="3" class="m-0 p-0">
            <!-- BUY: label + USD/COIN toggle справа. SELL: только
                 label (тогл не нужен, ввод сразу в coin). Разные
                 обёртки чтобы label не «прыгал» при переключении. -->
            <div v-if="buyForm.exType === 'BUY' && coinTicker" class="d-flex align-items-center justify-content-between">
              <label for="buySum" class="reg-label mb-0">Сумма</label>
              <div class="unit-switch">
                <button
                  type="button"
                  class="unit-chip"
                  :class="{ 'is-active': inputUnit === 'USD' }"
                  @click="setInputUnit('USD')"
                >USD</button>
                <button
                  type="button"
                  class="unit-chip"
                  :class="{ 'is-active': inputUnit === 'COIN' }"
                  @click="setInputUnit('COIN')"
                >{{ coinTicker }}</button>
              </div>
            </div>
            <label v-else for="buySum" class="reg-label">Количество монет</label>

            <div class="field-wrap mt-1" :class="{ 'field-error': showErrors && !isAmountValid }">
              <input
                type="number"
                id="buySum"
                class="reg-input w-100 p-2"
                step="any"
                required
                placeholder="0.00"
                v-model.number="displayAmount"
                @input="onAnyInput()"
              />
              <div class="field-hint" v-if="showErrors && !isAmountValid">
                <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
                {{ buyForm.exType === "SELL" ? "Введите количество больше 0" : "Введите сумму больше 0" }}
              </div>
              <div class="field-hint" v-else-if="buyForm.exType === 'SELL' && sellExceedsBalance">
                <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
                Недостаточно на балансе. Доступно {{ fmtNum(availableForSell, 8) }} {{ (selectedCoin.symbol || '').toUpperCase() }}
              </div>
              <div class="field-hint" v-else-if="buyForm.exType === 'BUY' && buyExceedsBalance">
                <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
                Недостаточно USD на балансе. Нужно {{ fmtNum(buyTotalDebitUsd, 2) }}, доступно {{ fmtNum(availableUsd, 2) }} USD
              </div>
            </div>

            <!-- SELL: подсвечиваем доступный остаток выбранного актива,
                 чтобы клиент не сверялся вручную в «Мои Балансы». -->
            <div v-if="buyForm.exType === 'SELL' && selectedCoin.symbol" class="sell-balance-line mt-2">
              <span class="muted-mini">
                Доступно на балансе:
                <span class="text-strong">{{ fmtNum(availableForSell, 8) }} {{ (selectedCoin.symbol || '').toUpperCase() }}</span>
              </span>
              <a v-if="availableForSell > 0" href="javascript:void(0)" class="sell-max-link" @click="sellMax()">Продать всё</a>
            </div>

            <!-- BUY: доступный USD-баланс, с которого спишется покупка. -->
            <div v-if="buyForm.exType === 'BUY'" class="sell-balance-line mt-2">
              <span class="muted-mini">
                Доступно на балансе:
                <span class="text-strong">{{ fmtNum(availableUsd, 2) }} USD</span>
              </span>
            </div>

            <small v-if="buyForm.exType === 'SELL'" class="muted-mini d-inline-block mt-2">
              Примерно: <span class="text-strong">${{ approxUsdFromToken }}</span> по текущей цене
            </small>
            <small v-else-if="amountPreviewText" class="muted-mini d-inline-block mt-2">
              Примерно: <span class="text-strong">{{ amountPreviewText }}</span> по текущей цене
            </small>
          </b-col>

          <!-- Currency: dropdown с одним значением бесполезен. Для
               BUY показываем читаемый readonly (клиент платит в USD).
               Для SELL — читаемый «Вы получите USD», семантически
               яснее чем «Валюта». -->
          <b-col lg="3" class="m-0 p-0 pl-2 pt-1">
            <label class="reg-label">{{ buyForm.exType === 'SELL' ? 'Получите в' : 'Валюта' }}</label>
            <div class="field-wrap">
              <div class="form-control select-dark select-dark--readonly">
                USD — Доллар США
              </div>
            </div>
          </b-col>

          <!-- Network — driven by /exchange/asset-networks catalogue.
               Hidden when the chosen asset is single-network (BTC/ETH/SOL)
               — value is auto-set from the catalogue default. -->
          <b-col lg="3" class="m-0 p-0 pl-2 pt-1" v-if="networkOptionsForSelected.length > 1">
            <label class="reg-label">Сеть</label>

            <div class="field-wrap" :class="{ 'field-error': showErrors && !isNetworkValid }">
              <select class="form-control select-dark" v-model="buyForm.network" @change="onNetworkChange">
                <option value="" disabled>Выберите сеть</option>
                <option
                  v-for="opt in networkOptionsForSelected"
                  :key="opt.networkCode"
                  :value="opt.networkCode"
                >{{ opt.networkName }}{{ opt.tokenStandard ? ` (${opt.tokenStandard})` : '' }}{{ opt.nativeFeeEst != null ? ` · ~$${opt.nativeFeeEst}` : '' }}</option>
              </select>

              <div class="field-hint" v-if="showErrors && !isNetworkValid">
                <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
                Выберите сеть
              </div>
            </div>
          </b-col>
          <b-col lg="3" class="m-0 p-0 pl-2 pt-1" v-else-if="networkOptionsForSelected.length === 1">
            <label class="reg-label">Сеть</label>
            <div class="field-wrap">
              <div class="form-control select-dark select-dark--readonly">
                {{ networkOptionsForSelected[0].networkName }}{{ networkOptionsForSelected[0].tokenStandard ? ` (${networkOptionsForSelected[0].tokenStandard})` : '' }}
              </div>
            </div>
          </b-col>

          <!-- Wallet / Bank -->
          <b-col lg="3" class="m-0 p-0 pt-1 pl-2 text-right">
            <template v-if="buyForm.exType === 'BUY'">
              <label class="reg-label">Цифровой кошелек</label>

              <div class="field-wrap" :class="{ 'field-error': showErrors && !isWalletValid }">
                <select class="form-control select-dark" v-model.number="buyForm.digitalWalletId" @change="onAnyInput()">
                  <option :value="0" disabled>{{ filteredWallets.length ? 'Выберите кошелек' : 'Нет кошельков для этой сети' }}</option>
                  <option v-for="wallet in filteredWallets" :key="wallet.digitalWalletId" :value="wallet.digitalWalletId">
                    {{ wallet.walletName }} — {{ wallet.walletHash }}
                  </option>
                </select>
                <div class="field-hint" v-if="showErrors && !isWalletValid">
                  <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
                  {{ filteredWallets.length ? 'Выберите цифровой кошелек' : 'Добавьте кошелек этой сети в профиле' }}
                </div>
              </div>
            </template>

            <template v-else>
              <label class="reg-label">Банковский счет</label>

              <div class="field-wrap" :class="{ 'field-error': showErrors && !isBankAccountValid }">
                <select class="form-control select-dark" v-model.number="buyForm.bankAccountId" @change="onAnyInput()">
                  <option :value="0" disabled>Выберите счет</option>
                  <option v-for="acc in bankAccounts" :key="acc.digitalWalletId" :value="acc.digitalWalletId">
                    {{ acc.walletName }} — {{ acc.bankAccount }}
                  </option>
                </select>

                <div class="field-hint" v-if="showErrors && !isBankAccountValid">
                  <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
                  Выберите банковский счет
                </div>
              </div>
            </template>
          </b-col>
        </b-row>

        <!-- Empty-state nudge: user picked a coin but has no matching
             wallet (BUY) or no bank account at all (SELL). Without this
             the user just sees a disabled select and a dead-end. We
             stash the in-progress form in localStorage and bounce them
             to /digitalwallet with returnTo set; on return mounted()
             restores the form so they pick up where they left off. -->
        <div v-if="walletEmptyState" class="wallet-empty mt-3">
          <div class="d-flex align-items-start">
            <div class="wallet-empty-ic mr-3">
              <b-icon :icon="buyForm.exType === 'SELL' ? 'bank' : 'wallet2'"></b-icon>
            </div>
            <div class="flex-grow-1">
              <div class="wallet-empty-title">{{ walletEmptyState.title }}</div>
              <div class="wallet-empty-body mt-1">{{ walletEmptyState.body }}</div>
            </div>
            <div>
              <button type="button" class="wallet-empty-cta" @click="goAddWallet">
                {{ walletEmptyState.cta }}
              </button>
            </div>
          </div>
        </div>

        <!-- SELL продаёт крипту с внутреннего баланса (balance-first).
             Легаси per-order отправка на кошелёк брокера + токен
             транзакции удалены — крипта уже на балансе через «Пополнить». -->

        <!-- Summary -->
        <div class="summary-card mt-4">
          <b-row class="m-0 p-0">
            <b-col lg="6" class="m-0 p-0">
              <div class="sum-big">
                <!-- ✅ SELL: net = sum - fee -->
                <template v-if="buyForm.exType === 'SELL'">
                  {{ formattedUsdNetSell }}
                </template>
                <!-- ✅ BUY: show coin qty -->
                <template v-else>
                  {{ formattedCoinAmount }}
                </template>
              </div>

              <div class="sum-sub text-muted">Вы получите (примерно)</div>
            </b-col>

            <b-col lg="6" class="m-0 p-0 text-right">
              <!-- SELL: клиент получает USD на банк, тикер = USD.
                   BUY: получает крипту, тикер = монета. -->
              <div class="sum-big text-uppercase">{{ buyForm.exType === 'SELL' ? 'USD' : selectedCoin.symbol }}</div>
              <div class="sum-sub text-muted">Тикер</div>
            </b-col>
          </b-row>

          <div class="list-sep my-3"></div>

          <!-- Курс — предварительный, mid-цена CoinGecko. Реальный
               курс фиксируется на момент клика «Купить» и может
               отличаться от индикативного на 0.1-0.5%. -->
          <b-row class="m-0 p-0 mt-1">
            <b-col lg="6" class="m-0 p-0">
              <span class="info-left">Предварительный курс</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right">
              <span class="coin-sum">
                1 {{ (selectedCoin.symbol || '').toUpperCase() }} ≈ ${{ selectedCoin.current_price | money }}
              </span>
            </b-col>
          </b-row>

          <b-row class="m-0 p-0 mt-2">
            <b-col lg="6" class="m-0 p-0">
              <span class="info-left">{{ buyForm.exType === "SELL" ? "Количество" : "Сумма" }}</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right">
              <span class="coin-sum">
                {{ buyForm.buyAmount || 0 }} {{ buyForm.exType === "SELL" ? (selectedCoin.symbol || "") : "USD" }}
              </span>
            </b-col>
          </b-row>

          <!-- Service fee -->
          <b-row class="m-0 p-0 mt-2">
            <b-col lg="6" class="m-0 p-0">
              <span class="info-left">Комиссия Payton ({{ commissionPercentText }})</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right">
              <span class="coin-sum">{{ serviceFeeDisplay }}</span>
            </b-col>
          </b-row>

          <!-- Network fee — indicative, blockchain gas estimate from catalogue -->
          <b-row v-if="buyForm.exType === 'BUY' && selectedNetworkFeeEst != null" class="m-0 p-0 mt-2">
            <b-col lg="6" class="m-0 p-0">
              <span class="info-left">Сетевой сбор</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right">
              <span class="coin-sum">{{ selectedNetworkFeeText }}</span>
            </b-col>
          </b-row>

          <!-- ✅ BUY only: total -->
          <b-row v-if="buyForm.exType === 'BUY'" class="m-0 p-0 mt-2">
            <b-col lg="6" class="m-0 p-0">
              <span class="info-left">Всего</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right">
              <span class="coin-sum">{{ finalSum }}</span>
            </b-col>
          </b-row>

          <!-- ✅ SELL only: сколько крипты спишется (проданное + комиссия) -->
          <b-row v-if="buyForm.exType === 'SELL'" class="m-0 p-0 mt-2">
            <b-col lg="6" class="m-0 p-0">
              <span class="info-left">Всего к списанию</span>
            </b-col>
            <b-col lg="6" class="m-0 p-0 text-right">
              <span class="coin-sum">{{ fmtNum(sellTotalDebitCrypto, 8) }} {{ (selectedCoin.symbol || '').toUpperCase() }}</span>
            </b-col>
          </b-row>
        </div>

        <!-- Final disclaimer right before the action button. Network fee
             is shown again in stronger wording so the user can't claim
             they didn't see it when they later dispute the final amount. -->
        <div v-if="buyForm.exType === 'BUY'" class="fee-final-note mt-3">
          <b-icon icon="info-circle" class="mr-2"></b-icon>
          <span>
            Курс и сетевой сбор индикативны. Окончательная сумма фиксируется
            в момент исполнения заявки.
          </span>
        </div>

        <!-- Bottom actions -->
        <b-row class="m-0 p-0 mt-4 align-items-center">
          <b-col lg="4" class="m-0 p-0">
            <div class="py-2 px-3 cancel-btn text-center" style="width: 120px; cursor: pointer;" @click="buyCrypto(0)">
              <span class="cancel-btn-text">Отмена</span>
            </div>
          </b-col>

          <b-col lg="4" class="m-0 p-0 text-center">
            <transition name="fade">
              <div v-if="showErrors && !isFormComplete" class="inline-error">
                <b-icon icon="exclamation-triangle" class="mr-2"></b-icon>
                <span v-if="buyForm.exType === 'SELL' && sellExceedsBalance">Недостаточно средств на балансе — уменьшите количество</span>
                <span v-else-if="buyForm.exType === 'BUY' && buyExceedsBalance">Недостаточно USD на балансе — уменьшите сумму или пополните счёт</span>
                <span v-else-if="buyForm.exType === 'SELL'">Заполните все поля: количество, валюта, сеть и банковский счет</span>
                <span v-else>Заполните все поля: сумма, валюта, сеть и кошелек</span>
              </div>
            </transition>
          </b-col>

          <b-col lg="4" class="m-0 p-0 text-right">
            <div class="py-2 px-3 reg-btn text-center" :class="{ 'reg-btn-disabled': !isFormComplete || isOverMonthlyLimit }" @click="onSubmitClick()">
              <span class="login-btn-text">
                <a href="javascript:void(0)" class="no-style">Я понял, продолжай</a>
              </span>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { apiDomain, getHeader } from "@/config/config";
import BankInfo from "@/components/landing/BankInfo";

export default {
  name: "BuyCrypto",
  components: { BankInfo },
  data() {
    return {
      step: 0,
      coins: [],
      coinsLoading: true,
      selectedCoin: {},
      coinFilter: "",
      showErrors: false,

      // BUY-side amount input toggle: "USD" — user types fiat,
      // "COIN" — user types the asset itself. The underlying
      // buyForm.buyAmount stays denominated in USD; the toggle only
      // changes what shows up in the input field.
      inputUnit: "USD",

      // Draft для COIN-режима: хранит ровно то что набрал юзер, без
      // round-trip через USD. buyForm.buyAmount по-прежнему в USD
      // (для лимитов / комиссий) — при вводе в COIN обновляем и
      // draft, и USD; при выводе показываем draft. Без draft'а
      // getter пересчитывал бы USD→coin с float-дрейфом на 8-м знаке.
      coinInputDraft: 0,

      // CoinGecko id from a restored draft, applied as soon as the
      // coin list arrives. Empty when there's no pending draft.
      pendingDraftCoinId: "",

      buyForm: {
        buyAmount: 0,
        transactionDoc: null,
        digitalWalletId: 0,
        bankAccountId: 0,
        transactionId: "",
        buyCount: 0,
        exType: "",
        currency: "USD",
        network: "", // ✅ NEW
      },

      items: [],
      wallets: [],
      bankAccounts: [],
      balances: [],

      // /exchange/asset-networks catalogue — drives the network picker
      // and the wallet filter. Loaded once on mount; assets list itself
      // is short so we don't paginate.
      assetCatalog: [],

      brokerInfo: {
        name: "Payton Broker",
        walletHash: "BROKER-WALLET-WILL-BE-FILLED-BY-API",
        network: "", // optional mirror
      },
      commissions: [],
      loadedUserData: {},

      // Свежий месячный лимит: { limit, used, remaining } из
      // /exchange/limit. Обновляется при mount и после успешного
      // создания ордера (чтобы «доступно» тут же уменьшилось).
      monthlyLimit: null,
    };
  },

  computed: {
    ...mapState(["loginedUser"]),
    limitInvestment() {
      // Полный месячный потолок — из lms_core_user.limit_investment.
      // Для RETAIL_NQ = $1000, для VIP/Professional больше.
      return Number(this.loadedUserData.limitInvestment || 0);
    },
    limitRemaining() {
      // Остаток лимита на этот месяц: limit − used (сумма ордеров
      // с 1-го числа). Приходит из /exchange/limit. Пока не подгружен
      // — считаем полный limit (не хуже чем прошлое поведение).
      if (this.monthlyLimit && this.monthlyLimit.remaining !== undefined) {
        return Number(this.monthlyLimit.remaining) || 0;
      }
      return this.limitInvestment;
    },
    limitUsed() {
      if (this.monthlyLimit && this.monthlyLimit.used !== undefined) {
        return Number(this.monthlyLimit.used) || 0;
      }
      return 0;
    },
    buyTotalRequired() {
      const usd = this.baseUsdAmount || 0;
      const fee = this.serviceFeeValueUsd || 0;
      return usd + fee;
    },
    // Set из тикеров поддерживаемых активов (BTC/ETH/USDT/USDC/SOL).
    // Берём из /exchange/asset-networks (assetCatalog), которое уже
    // подгружено к этому моменту. Если каталог ещё пуст (race до
    // первого ответа) — возвращаем пустой Set, и filteredCoins
    // покажет «загрузка»; это лучше чем 100 крипто-монет CoinGecko
    // из которых мы поддерживаем 5%.
    supportedTickers() {
      if (!this.assetCatalog || !this.assetCatalog.length) return null;
      return new Set(this.assetCatalog.map((a) => (a.code || "").toUpperCase()));
    },
    filteredCoins() {
      const tickers = this.supportedTickers;
      // Каталог ещё не приехал — не показываем сырой CoinGecko список
      // целиком; вернём пустоту, UI отрисует «загрузка». Когда catalogue
      // придёт, computed пересчитается.
      if (!tickers) return [];

      // 1. Оставляем только те, чей символ присутствует в нашем
      //    каталоге (CoinGecko отдаёт lowercase, наш каталог uppercase).
      const supported = this.coins.filter(
        (c) => tickers.has((c.symbol || "").toUpperCase()),
      );

      // 2. Применяем пользовательский поиск поверх отфильтрованного.
      const q = (this.coinFilter || "").toLowerCase().trim();
      if (!q) return supported;
      return supported.filter((c) => {
        const id = (c.id || "").toLowerCase();
        const sym = (c.symbol || "").toLowerCase();
        return id.includes(q) || sym.includes(q);
      });
    },

    // Pick out the catalogue entry for the asset the user just chose.
    // selectedCoin.symbol comes from CoinGecko (lowercase, no spaces);
    // our catalogue stores uppercase ticker — uppercase the lookup.
    selectedAssetCatalog() {
      const ticker = (this.selectedCoin && this.selectedCoin.symbol || "").toUpperCase();
      if (!ticker) return null;
      return (this.assetCatalog || []).find((a) => a.code === ticker) || null;
    },
    // Networks available for the picked asset, ordered the way the
    // backend sorted them (isDefault first). When length === 1 the
    // network picker hides and the value gets auto-set.
    networkOptionsForSelected() {
      const asset = this.selectedAssetCatalog;
      if (!asset || !Array.isArray(asset.networks)) return [];
      return asset.networks;
    },
    // Empty-state config for the wallet/bank picker. Returns null when
    // the user already has at least one suitable entry — the card is
    // only rendered when there's actually a gap to fill, so we don't
    // distract people who set everything up already.
    walletEmptyState() {
      if (this.buyForm.exType === "BUY") {
        const haveAnyCrypto = (this.wallets || []).some((wallet) => (wallet.walletType || "").toLowerCase() === "crypto");
        const needsForThisNetwork = !this.filteredWallets.length;
        if (!needsForThisNetwork) return null;
        if (!haveAnyCrypto) {
          return {
            title: "У вас пока нет цифрового кошелька",
            body: "Добавьте кошелёк, чтобы получить купленную крипту. После сохранения мы вернём вас сюда.",
            cta: "Добавить кошелёк",
          };
        }
        const networkLabel = (this.networkOptionsForSelected[0] || {}).networkName || (this.buyForm.network || "");
        return {
          title: "Нет кошелька для выбранной сети",
          body: "Сеть " + networkLabel + " не найдена в ваших кошельках. Добавьте подходящий — заявку завершите за пару кликов.",
          cta: "Добавить кошелёк",
        };
      }
      if (this.buyForm.exType === "SELL" && !(this.bankAccounts || []).length) {
        return {
          title: "У вас пока нет банковского счёта",
          body: "Добавьте банковский счёт, чтобы получить выплату. После сохранения мы вернём вас сюда.",
          cta: "Добавить счёт",
        };
      }
      return null;
    },

    // Crypto wallets that match the (asset, network) the user picked.
    // For SoF-side flows (SELL) we keep the legacy "all wallets" list —
    // not implementing the matcher there until the SELL flow's CJM
    // is brought up to date too.
    filteredWallets() {
      // Только крипто-кошельки — при переключении BUY↔SELL раньше
      // BankAccount'ы попадали в crypto-picker если у них было
      // пустое asset/network. Отсекаем сразу по walletType.
      const list = (Array.isArray(this.wallets) ? this.wallets : [])
        .filter((w) => (w.walletType || "").toString().toLowerCase() === "crypto");
      const network = (this.buyForm.network || "").trim();
      if (!network) return list;
      // Совпадение по СЕТИ, а не по активу: адрес на цепи принимает любой
      // её актив, поэтому кошелёк «USDC/Solana» подходит и для покупки SOL.
      return list.filter((wallet) => {
        const walletNet = (wallet.networkCode || "").trim();
        // Легаси-строки без сети показываем — бэкенд отклонит несовпадение.
        if (!walletNet) return true;
        return walletNet === network;
      });
    },
    // Native blockchain fee estimate for the currently selected network —
    // surfaces in the order summary so the user sees rough cost upfront.
    selectedNetworkFeeEst() {
      const network = this.buyForm.network;
      const list = this.networkOptionsForSelected;
      if (!network || !list.length) return null;
      const match = list.find((opt) => opt.networkCode === network);
      return match ? match.nativeFeeEst : null;
    },
    selectedNetworkFeeText() {
      const fee = this.selectedNetworkFeeEst;
      if (fee == null) return "—";
      return "$" + this.fmtNum(fee, 2);
    },
    isAmountValid() {
      return Number(this.buyForm.buyAmount) > 0;
    },
    // Доступный баланс выбранного крипто-актива под текущую сеть.
    // Матчим asset+network точно так же, как сервер при резерве, чтобы
    // подсказка совпадала с реальной проверкой ReserveBalance.
    availableForSell() {
      if (this.buyForm.exType !== "SELL") return 0;
      const asset = (this.selectedCoin.symbol || "").toUpperCase();
      const network = (this.buyForm.network || "").trim();
      if (!asset) return 0;
      const row = (this.balances || []).find(
        (balance) => (balance.asset || "").toUpperCase() === asset &&
          (balance.network || "").trim() === network,
      );
      return row ? Number(row.available) || 0 : 0;
    },
    // SELL: с баланса спишется проданное + комиссия сверху, поэтому
    // сравниваем полное списание с доступным остатком.
    sellExceedsBalance() {
      if (this.buyForm.exType !== "SELL") return false;
      return this.sellTotalDebitCrypto > this.availableForSell;
    },
    // Доступный USD-баланс под покупку. Сервер резервирует на
    // (asset=USD, network=""), поэтому матчим ровно так же.
    availableUsd() {
      const row = (this.balances || []).find(
        (balance) => (balance.asset || "").toUpperCase() === "USD" &&
          (balance.network || "").trim() === "",
      );
      return row ? Number(row.available) || 0 : 0;
    },
    // BUY: полное списание в USD = база + комиссия + сетевой сбор сверху.
    // Совпадает с sellStored на сервере — подсказка = реальному резерву.
    buyTotalDebitUsd() {
      if (this.buyForm.exType !== "BUY") return 0;
      const base = this.baseUsdAmount || 0;
      const svcFee = this.serviceFeeValueUsd || 0;
      const netFee = Number(this.selectedNetworkFeeEst) || 0;
      return base + svcFee + netFee;
    },
    buyExceedsBalance() {
      if (this.buyForm.exType !== "BUY") return false;
      return this.buyTotalDebitUsd > 0 && this.buyTotalDebitUsd > this.availableUsd;
    },
    isCurrencyValid() {
      return !!this.buyForm.currency;
    },
    isNetworkValid() {
      return (this.buyForm.network || "").trim().length > 0;
    },

    isWalletValid() {
      return Number(this.buyForm.digitalWalletId) !== 0;
    },
    isBankAccountValid() {
      return Number(this.buyForm.bankAccountId) !== 0;
    },

    isFormComplete() {
      if (this.buyForm.exType === "SELL") {
        return this.isAmountValid && this.isCurrencyValid && this.isNetworkValid &&
          this.isBankAccountValid && !this.sellExceedsBalance;
      }
      return this.isAmountValid && this.isCurrencyValid && this.isNetworkValid &&
        this.isWalletValid && !this.buyExceedsBalance;
    },

    // Uppercased ticker of the picked coin (BTC, ETH, USDT…). Used as
    // the label of the second chip in the unit switcher.
    coinTicker() {
      return ((this.selectedCoin && this.selectedCoin.symbol) || "").toString().toUpperCase();
    },

    // Two-way binding for the amount input. When the user is on the
    // "coin" tab the field shows coin units and writes back into
    // buyForm.buyAmount as USD (qty * current price).
    displayAmount: {
      get() {
        // Пустое поле вместо «0» — иначе type=number показывает '0',
        // и юзер видит «10» когда набирает 1 (курсор после нуля),
        // либо получает искажённую сумму. Возвращаем "" при 0.
        let raw;
        if (this.buyForm.exType !== "BUY" || this.inputUnit === "USD") {
          raw = this.buyForm.buyAmount;
        } else {
          raw = this.coinInputDraft;
        }
        return (Number(raw) || 0) === 0 ? "" : raw;
      },
      set(rawValue) {
        const value = Number(rawValue) || 0;
        if (this.buyForm.exType !== "BUY" || this.inputUnit === "USD") {
          this.buyForm.buyAmount = value;
          return;
        }
        // COIN-режим (модель «комиссия и сеть сверху»): клиент получает
        // ровно столько монет, сколько ввёл (брутто). База = target ×
        // price; комиссия и сетевой сбор добавятся сверху к списанию и
        // объём крипты не трогают — поэтому НИКАКОГО gross-up.
        //   backend: buy = base / price = target.
        const price = Number(this.selectedCoin.current_price) || 0;
        this.coinInputDraft = value;
        this.buyForm.buyAmount = price > 0 ? Number((value * price).toFixed(2)) : 0;
      },
    },

    // Sub-line under the amount input — flips depending on which unit
    // the user is typing in. USD tab → "≈ 0.0123 BTC", coin tab → "≈ $1234.56".
    amountPreviewText() {
      if (this.buyForm.exType !== "BUY") return "";
      const price = Number(this.selectedCoin.current_price) || 0;
      const usd = Number(this.buyForm.buyAmount) || 0;
      if (!price || !usd) return "";
      const fmtUsd = (v) => "$" + this.fmtNum(v, 2);
      const fmtCoin = (v) => this.fmtNum(v, 8) + " " + this.coinTicker;
      return this.inputUnit === "USD" ? fmtCoin(usd / price) : fmtUsd(usd);
    },

    // USD base for commission lookup
    baseUsdAmount() {
      if (this.buyForm.exType === "SELL") {
        const tokenQty = Number(this.buyForm.buyAmount) || 0;
        const price = Number(this.selectedCoin.current_price) || 0;
        return tokenQty * price;
      }
      return Number(this.buyForm.buyAmount) || 0;
    },

    // Find tier + convert to decimal fraction
    commissionPercentDecimal() {
      return this.pickFeePctForUsd(this.baseUsdAmount);
    },

    commissionPercentText() {
      const p = this.commissionPercentDecimal || 0;
      const percent = p * 100;
      return this.fmtNum(percent, 2) + "%";
    },

    serviceFeeValueUsd() {
      return (this.baseUsdAmount || 0) * (this.commissionPercentDecimal || 0);
    },

    serviceFeeText() {
      const fee = this.serviceFeeValueUsd || 0;
      return this.fmtNum(fee, 2) + " USD";
    },
    // Комиссия при продаже — в самом крипто-активе (USDT/BTC/…), а не в
    // фиате: клиент, который завёл только крипту, не нуждается в USD-
    // балансе. Экономически = serviceFeeValueUsd / mid = qty × fee_pct.
    serviceFeeCrypto() {
      const qty = Number(this.buyForm.buyAmount) || 0; // SELL: количество монет
      return qty * (this.commissionPercentDecimal || 0);
    },
    // Строка комиссии: для SELL — в крипте, для BUY — в USD.
    serviceFeeDisplay() {
      if (this.buyForm.exType === "SELL") {
        const ticker = (this.selectedCoin.symbol || "").toUpperCase();
        return this.fmtNum(this.serviceFeeCrypto, 8) + " " + ticker;
      }
      return this.serviceFeeText;
    },

    finalSum() {
      // Клиент видит три строки: «Сумма» (base USD), «Комиссия»
      // (service fee) и «Сетевой сбор» (network fee). Логичное
      // «Всего» — их сумма, как и мысленно складывает клиент:
      //   Всего ≈ Сумма + Комиссия + Network fee
      // Тильда — network fee и market rate индикативные.
      const sellUsd = this.baseUsdAmount || 0;
      const svcFee = this.serviceFeeValueUsd || 0;
      const netFee = Number(this.selectedNetworkFeeEst) || 0;
      const total = sellUsd + svcFee + netFee;
      return this.fmtNum(total, 2) + " USD";
    },

    // BUY: user inputs USD -> show token qty
    formattedCoinAmount() {
      // COIN-режим: юзер задал target через draft — это же и получит.
      if (this.buyForm.exType === "BUY" && this.inputUnit === "COIN") {
        return this.fmtNum(Number(this.coinInputDraft) || 0, 8);
      }
      // USD-режим: модель «комиссия и сеть сверху» — клиент получает
      // брутто по курсу (sellAmount / price), а комиссия и сетевой сбор
      // добавляются к списанию (см. «Всего»). Поэтому «Вы получите»
      // совпадает с подсказкой «Примерно».
      const amountUsd = Number(this.buyForm.buyAmount) || 0;
      const price = Number(this.selectedCoin.current_price) || 0;
      if (!amountUsd || !price) return "0";
      const grossCoin = amountUsd / price;
      return this.fmtNum(grossCoin, 8);
    },

    // SELL helper (gross)
    approxUsdFromToken() {
      const usd = this.baseUsdAmount || 0;
      return this.fmtNum(usd, 2);
    },

    // SELL: клиент получает ПОЛНУЮ USD-стоимость проданных монет
    // (брутто). Комиссия удерживается сверху в крипте (см. «Всего к
    // списанию»), поэтому USD-выплата не уменьшается.
    grossSellUsd() {
      if (this.buyForm.exType !== "SELL") return 0;
      return this.baseUsdAmount || 0;
    },

    formattedUsdNetSell() {
      const v = this.grossSellUsd || 0;
      return "$" + this.fmtNum(v, 2);
    },

    // SELL: сколько крипты реально спишется = проданное + комиссия сверху.
    sellTotalDebitCrypto() {
      const qty = Number(this.buyForm.buyAmount) || 0;
      return qty + (this.serviceFeeCrypto || 0);
    },

    isOverMonthlyLimit() {
      // Проверяем оставшийся лимит (limit − used за текущий месяц),
      // а не полный. Учитываем sellAmount (что реально спишем)
      // а не baseUsdAmount, чтобы включить комиссию.
      const usd = Number(this.buyForm.buyAmount) || 0;
      return this.limitInvestment > 0 && usd > this.limitRemaining;
    },
  },

  methods: {
    // fmtNum — форматирование числа с NBSP-разделителем тысячных и
    // точкой в качестве десятичной. Замена запятой на пробел даёт
    // «1 000.50» вместо «1,000.50». Единая точка входа — чтобы
    // не дублировать паттерн Intl.NumberFormat + .replace по всему
    // компоненту.
    fmtNum(v, decimals = 2) {
      const n = Number(v);
      if (!Number.isFinite(n)) return "";
      return new Intl.NumberFormat("en-US", { maximumFractionDigits: decimals }).format(n).replace(/,/g, " ");
    },
    // pickFeePctForUsd — общая точка входа для лукапа комиссионного
    // тира по USD-сумме. Возвращает decimal fraction (0.0015 = 0.15%).
    // Используется и в commissionPercentDecimal (реактивный), и в
    // displayAmount.set для итеративного расчёта sellAmount.
    pickFeePctForUsd(usd) {
      const list = Array.isArray(this.commissions) ? this.commissions : [];
      if (!list.length || !usd) return 0;
      const sorted = [...list].sort((a, b) => Number(a.fromAmount) - Number(b.fromAmount));
      const match = sorted.find((r) => usd >= Number(r.fromAmount) && usd <= Number(r.toAmount));
      const picked = match || sorted[sorted.length - 1];
      const raw = Number(picked.percent) || 0;
      return raw > 0 ? raw / 100 : 0;
    },
    // formatChangePct — форматирует price_change_percentage_24h из
    // CoinGecko: 2 знака после запятой, явный знак +/− (минус —
    // U+2212 для типографической правильности). null / undefined
    // безопасно превращаются в «0.00%».
    formatChangePct(value) {
      const n = Number(value || 0);
      const abs = Math.abs(n).toFixed(2);
      if (n > 0) return "+" + abs + "%";
      if (n < 0) return "−" + abs + "%";
      return abs + "%";
    },
    onAnyInput() {},
    // Switch the amount field between USD and coin entry. Because
    // buyForm.buyAmount stays in USD, no value conversion is needed
    // — the field just re-renders through `displayAmount`.
    // Stash the in-progress order to localStorage and bounce the user
    // to /digitalwallet with a returnTo flag. The wallets page picks
    // up the flag and routes back here once the new entry is saved;
    // mounted() reads the stashed draft and re-hydrates buyForm so
    // the user doesn't lose their amount / coin / network choice.
    goAddWallet() {
      const draft = {
        savedAt: this.draftTimestamp(),
        exType: this.buyForm.exType,
        coinId: (this.selectedCoin && this.selectedCoin.id) || "",
        coinSymbol: (this.selectedCoin && this.selectedCoin.symbol) || "",
        buyAmount: this.buyForm.buyAmount,
        currency: this.buyForm.currency,
        network: this.buyForm.network,
        inputUnit: this.inputUnit,
      };
      try {
        localStorage.setItem("buyCryptoDraft", JSON.stringify(draft));
      } catch (storageError) {
        console.warn("buyCryptoDraft stash failed", storageError);
      }
      const returnTo = "/buy/" + this.buyForm.exType;
      const intent = this.buyForm.exType === "SELL" ? "bank" : "crypto";
      this.$router.push({ path: "/digitalwallet", query: { returnTo: returnTo, intent: intent } });
    },
    // Centralized — keeps the test plan simple if we ever mock Date.
    draftTimestamp() {
      return new Date().toISOString();
    },
    // After /digitalwallet → /buy/BUY round-trip restore the form so
    // the user resumes at the same step. We only restore if the type
    // matches the route and the draft is < 30 min old (anything older
    // is probably abandoned).
    restoreDraftIfAny() {
      let raw;
      try {
        raw = localStorage.getItem("buyCryptoDraft");
      } catch (storageError) {
        return;
      }
      if (!raw) return;
      let draft;
      try { draft = JSON.parse(raw); } catch (parseError) { return; }
      try { localStorage.removeItem("buyCryptoDraft"); } catch (cleanupError) { /* ignore */ }
      if (!draft || draft.exType !== this.buyForm.exType) return;
      const savedAt = Date.parse(draft.savedAt || "");
      if (Number.isFinite(savedAt) && (new Date().getTime() - savedAt) > 30 * 60 * 1000) return;

      this.buyForm.buyAmount = Number(draft.buyAmount) || 0;
      this.buyForm.currency = draft.currency || "USD";
      this.buyForm.network = draft.network || "";
      this.inputUnit = draft.inputUnit === "COIN" ? "COIN" : "USD";

      // Coin list is fetched async — once it lands, pick the same coin
      // back (id is the canonical key from CoinGecko).
      if (draft.coinId) {
        this.pendingDraftCoinId = draft.coinId;
        this.tryApplyDraftCoin();
      }
    },
    // Match the stashed coin id against the loaded coin list and
    // re-select. Called after coin list arrives.
    tryApplyDraftCoin() {
      if (!this.pendingDraftCoinId) return;
      const match = (this.coins || []).find((coin) => coin.id === this.pendingDraftCoinId);
      if (!match) return;
      this.selectedCoin = match;
      this.pendingDraftCoinId = "";
    },
    setExType(newType) {
      if (newType !== "BUY" && newType !== "SELL") return;
      if (this.buyForm.exType === newType) return;
      this.buyForm.exType = newType;
      // Сброс полей, специфичных для направления: destination wallet
      // нужен только BUY, bankaccount — только SELL. Amount тоже
      // сбрасываем — 100 USD в BUY и 100 coin в SELL это разные
      // суммы, оставлять число небезопасно.
      this.buyForm.digitalWalletId = 0;
      this.buyForm.bankAccountId = 0;
      this.buyForm.transactionId = "";
      this.buyForm.network = "";
      this.buyForm.buyAmount = 0;
      this.coinInputDraft = 0;
      this.inputUnit = "USD";
      this.showErrors = false;
      // Обновляем URL чтобы ссылка была shareable + browser back не
      // ломался. replace, не push — не засоряем history.
      const symbol = this.$route.params.symbol;
      if (symbol) {
        this.$router.replace({ name: "BuyCryptoForm", params: { exType: newType, symbol } }).catch(() => {});
      } else {
        this.$router.replace({ name: "BuyCrypto", params: { exType: newType } }).catch(() => {});
      }
      // Дефолтная сеть для выбранной монеты (если применимо).
      this.autoFillNetworkForSelected();
    },
    setInputUnit(unit) {
      if (unit !== "USD" && unit !== "COIN") return;
      if (unit === this.inputUnit) return;
      // Стабильный display при переключении режима: то число, что
      // юзер видит в поле, остаётся тем же, только меняет юнит.
      // Реинтерпретация меняет order-amount: 100 USDT (~100.02 USD)
      // → в USD-режиме становится ровно 100 USD (~99.98 USDT). Это
      // компромисс — вместо непонятного «мигания» на 0.02 клиент
      // видит стабильное число, а order-amount честно обновляется в
      // блоке итога ниже.
      const price = Number(this.selectedCoin.current_price) || 0;
      const currentDisplay = Number(this.displayAmount) || 0;
      if (unit === "USD") {
        // COIN → USD: число становится USD-суммой.
        this.buyForm.buyAmount = Number(currentDisplay.toFixed(2));
      } else {
        // USD → COIN: число становится coin-количеством. Draft
        // — источник истины для отображения, USD — производный.
        this.coinInputDraft = currentDisplay;
        this.buyForm.buyAmount = price > 0 ? Number((currentDisplay * price).toFixed(2)) : 0;
      }
      this.inputUnit = unit;
      this.onAnyInput();
    },
    // Asset/network catalogue is the source-of-truth for which
    // networks are valid for a given crypto — fetch once on mount.
    fetchAssetCatalog() {
      axios
        .get(apiDomain + "/exchange/asset-networks")
        .then((res) => {
          this.assetCatalog = Array.isArray(res.data) ? res.data : [];
          // Late-bind: if the user already picked a coin before the
          // catalogue arrived, reseat the default network.
          this.autoFillNetworkForSelected();
        })
        .catch(() => { this.assetCatalog = []; });
    },
    // fetchMonthlyLimit — тянет { limit, used, remaining } за текущий
    // календарный месяц. Вызывается при mount и после успешного
    // createOrder, чтобы UI сразу показал уменьшенный «доступно».
    fetchMonthlyLimit() {
      axios
        .get(apiDomain + "/exchange/limit", { headers: getHeader() })
        .then((res) => { this.monthlyLimit = res.data || null; })
        .catch(() => { this.monthlyLimit = null; });
    },
    // Whenever the asset / catalogue changes, lock the network to the
    // catalogue default. For single-network assets the picker hides;
    // for multi-network assets the user can override afterwards.
    autoFillNetworkForSelected() {
      const networks = this.networkOptionsForSelected;
      if (!networks.length) {
        this.buyForm.network = "";
        return;
      }
      const def = networks.find((n) => n.isDefault) || networks[0];
      this.buyForm.network = def.networkCode;
      // Reset wallet pick — the previously chosen wallet might not
      // exist on the new network.
      this.buyForm.digitalWalletId = 0;
    },
    onNetworkChange() {
      // Wallet must re-match the new network.
      this.buyForm.digitalWalletId = 0;
      this.onAnyInput();
    },

    copyText(text) {
      if (!text) return;
      try {
        navigator.clipboard.writeText(String(text));
        this.$bvToast.toast("Скопировано в буфер обмена.", {
          variant: "success",
          title: "Готово",
          autoHideDelay: 2500,
          toaster: "b-toaster-top-center",
          solid: true,
        });
      } catch (e) {
        this.$bvToast.toast("Не удалось скопировать.", {
          variant: "danger",
          title: "Ошибка",
          autoHideDelay: 3500,
          toaster: "b-toaster-top-center",
          solid: true,
        });
      }
    },

    createOrder() {
      this.showErrors = true;

      if (!this.selectedCoin.id) {
        this.$bvToast.toast("Сначала выберите криптовалюту.", {
          variant: "danger",
          title: "Ошибка",
          autoHideDelay: 4500,
          toaster: "b-toaster-top-center",
          solid: true,
        });
        return;
      }

      if (this.isOverMonthlyLimit) {
        const remStr = this.fmtNum(this.limitRemaining, 2) + " USD";
        const limStr = this.fmtNum(this.limitInvestment, 2) + " USD";
        this.$bvToast.toast(
          "Сумма ордера превышает доступный лимит инвестирования. Доступно " + remStr +
          " из " + limStr + " на этот месяц. Уменьшите сумму и попробуйте снова.",
          {
            variant: "danger",
            title: "Лимит",
            autoHideDelay: 5500,
            toaster: "b-toaster-top-center",
            solid: true,
          },
        );
        return;
      }

      if (!this.isFormComplete) {
        this.$bvToast.toast(
          this.buyForm.exType === "SELL"
            ? "Заполните все обязательные поля: количество, валюта, сеть и банковский счет."
            : "Заполните все обязательные поля: сумма, валюта, сеть и кошелек.",
          {
            variant: "danger",
            title: "Проверьте форму",
            autoHideDelay: 5000,
            toaster: "b-toaster-top-center",
            solid: true,
          }
        );
        return;
      }

      // SELL: жёсткий гейт по балансу до отправки — дублирует серверный
      // ReserveBalance, но даёт мгновенный понятный отказ вместо 422.
      if (this.buyForm.exType === "SELL" && this.sellExceedsBalance) {
        this.$bvToast.toast(
          "Недостаточно средств на балансе. Доступно " +
          this.fmtNum(this.availableForSell, 8) + " " +
          (this.selectedCoin.symbol || "").toUpperCase() + ". Уменьшите количество.",
          {
            variant: "danger",
            title: "Недостаточно средств",
            autoHideDelay: 5500,
            toaster: "b-toaster-top-center",
            solid: true,
          },
        );
        return;
      }

      // BUY: тот же жёсткий гейт по USD-балансу до отправки.
      if (this.buyForm.exType === "BUY" && this.buyExceedsBalance) {
        this.$bvToast.toast(
          "Недостаточно USD на балансе. Нужно " +
          this.fmtNum(this.buyTotalDebitUsd, 2) + ", доступно " +
          this.fmtNum(this.availableUsd, 2) + " USD. Уменьшите сумму или пополните счёт.",
          {
            variant: "danger",
            title: "Недостаточно средств",
            autoHideDelay: 5500,
            toaster: "b-toaster-top-center",
            solid: true,
          },
        );
        return;
      }

      // New balance-first flow: вместо legacy /exchange/create1 шлём
      // на POST /exchange/order с явными sell/buy сторонами. Сервер
      // делает fresh price fetch + ReserveBalance + INSERT в одной TX.
      // clientDisplayedPrice — то, что мы показали в UI; сервер
      // сверит с fresh-курсом и при дрифте > RATE_TOLERANCE_BPS
      // вернёт 409 (UI обновит и попросит подтвердить).
      const coinTicker = (this.selectedCoin.symbol || "").toUpperCase();
      const exType = this.buyForm.exType;

      let payload;
      if (exType === "BUY") {
        payload = {
          exType: "BUY",
          sellAsset:            "USD",
          sellNetwork:          "",
          sellAmount:           Number(this.buyForm.buyAmount) || 0, // USD amount
          buyAsset:             coinTicker,
          buyNetwork:           this.buyForm.network || "",
          destinationWalletId:  this.buyForm.digitalWalletId || null,
          clientDisplayedPrice: Number(this.selectedCoin.current_price) || 0,
        };
        // Режим «монеты» → якорь на точный объём крипты: сервер отдаст
        // ровно столько монет, а USD-списание пересчитает по свежему
        // курсу. В USD-режиме поле не шлём (якорь на сумму).
        if (this.inputUnit === "COIN") {
          payload.targetBuyAmount = Number(this.coinInputDraft) || 0;
        }
      } else {
        // SELL: клиент отдаёт X coin со своего баланса, бэкофис делает
        // ручной банковский перевод USD на его счёт. destinationWalletId
        // указывает на банковский счёт (p_digital_wallet, тип BankAccount).
        payload = {
          exType: "SELL",
          sellAsset:            coinTicker,
          sellNetwork:          this.buyForm.network || "",
          sellAmount:           Number(this.buyForm.buyAmount) || 0, // coin amount
          buyAsset:             "USD",
          buyNetwork:           "",
          destinationWalletId:  this.buyForm.bankAccountId || null,
          clientDisplayedPrice: Number(this.selectedCoin.current_price) || 0,
        };
      }

      // Зеркало для UI-блока «брокер»: показываем сеть, которую сейчас выбрали.
      this.brokerInfo.network = payload.exType === "BUY" ? payload.buyNetwork : payload.sellNetwork;

      axios
        .post(apiDomain + "/exchange/order", payload, { headers: getHeader() })
        .then((response) => {
          const orderId = (response.data && response.data.orderId) || 0;
          this.$bvToast.toast("Заявка №" + orderId + " создана. Курс зафиксирован.", {
            variant: "success",
            title: "Заявка отправлена",
            autoHideDelay: 3500,
            toaster: "b-toaster-top-center",
            solid: true,
          });
          this.clearForm();
          // Обновляем лимит — successful ордер уменьшил доступную квоту.
          this.fetchMonthlyLimit();
          // Редирект на экран ожидания с countdown'ом — это и есть
          // «после клика клиент видит свой ордер».
          if (orderId) {
            this.$router.push("/order/" + orderId + "/wait");
          } else {
            this.step = 3;
          }
        })
        .catch((error) => {
          // Маппинг новых sentinel-ошибок:
          //   409 stale-price            — fresh price ушёл > 0.3%
          //   422 insufficient-funds     — баланс не покрыл sell_amount
          //   422 unknown-asset-network  — пара не в каталоге
          //   422 invalid-destination-wallet — кошелёк чужой / другой сети
          let msg = "Не удалось создать заявку. Попробуйте позже.";
          let title = "Ошибка";
          const status = error.response && error.response.status;
          const body = error.response && typeof error.response.data === "string"
            ? error.response.data : "";
          if (status === 403 && body.indexOf("frozen") !== -1) {
            this.$bvToast.toast(
              "Аккаунт заморожен — операции покупки/продажи временно недоступны. Обратитесь в поддержку: support@payton.kz",
              { title: "Сервис недоступен", variant: "warning", autoHideDelay: 6000, toaster: "b-toaster-top-center", solid: true }
            );
            this.$router.replace("/userwallet").catch(() => {});
            return;
          }
          if (status === 409 && body.indexOf("stale-price") !== -1) {
            msg = "Цена обновилась за время оформления. Проверьте новую сумму и подтвердите заявку ещё раз.";
            title = "Курс изменился";
          } else if (status === 422 && body.indexOf("insufficient-funds") !== -1) {
            msg = "Недостаточно средств на балансе. Пополните счёт и попробуйте снова.";
            title = "Недостаточно средств";
          } else if (status === 422 && body.indexOf("invalid-destination-wallet") !== -1) {
            msg = "Выбранный кошелёк не подходит для этой пары. Выберите другой или добавьте новый в профиле.";
            title = "Кошелёк не подходит";
          } else if (status === 422 && body.indexOf("unknown-asset-network") !== -1) {
            msg = "Эта пара актива и сети сейчас недоступна.";
            title = "Пара недоступна";
          } else if (status === 422 && body.indexOf("monthly-limit-exceeded") !== -1) {
            // Server-side gate — обычно UI banner ловит это раньше,
            // но если клиент попал сюда через прямой API или race
            // с обновлением лимита — свежий fetch + текстовый toast.
            this.fetchMonthlyLimit();
            msg = "Сумма ордера превышает ваш месячный лимит инвестирования.";
            title = "Лимит";
          }
          this.$bvToast.toast(msg, {
            variant: "danger",
            title: title,
            autoHideDelay: 6000,
            toaster: "b-toaster-top-center",
            solid: true,
          });
        });
    },

    buyCrypto(step, selected) {
      // URL-driven navigation: клик по монете → /buy/BUY/btc, назад
      // → /buy/BUY. Синхронизация step + selectedCoin с URL живёт в
      // syncStepFromRoute() и watcher'е на $route.
      if (step === 1 && selected && selected.symbol) {
        const exType = this.$route.params.exType || "BUY";
        this.$router.push({ name: "BuyCryptoForm", params: { exType: exType, symbol: selected.symbol } })
          .catch(() => {});
        return;
      }
      // step 0 (назад к списку) или fallback без монеты.
      if (step === 0) {
        const exType = this.$route.params.exType || "BUY";
        this.$router.push({ name: "BuyCrypto", params: { exType: exType } }).catch(() => {});
        return;
      }
      // step 3 (success) остаётся in-place, для legacy-совместимости.
      this.selectedCoin = selected || {};
      this.step = step;
      if (step === 1) this.showErrors = false;
    },
    syncStepFromRoute() {
      const symbol = this.$route.params.symbol;
      if (!symbol) {
        // /buy/BUY — список.
        this.step = 0;
        this.selectedCoin = {};
        return;
      }
      // /buy/BUY/btc — форма для конкретной монеты. Если coins ещё
      // не подгрузились (прямой заход по ссылке), tryApplyDraftCoin()
      // после fetchCoins() отсинхронит.
      const match = (this.coins || []).find(c => (c.symbol || "").toLowerCase() === symbol.toLowerCase());
      if (match) {
        this.selectedCoin = match;
        this.step = 1;
        this.showErrors = false;
      }
    },

    // Фолбэк, если иконка монеты не загрузилась (hotlink-блок CDN, оффлайн
    // и т.п.) — подставляем нейтральный кружок с монеткой, чтобы не было
    // «сломанной картинки». Guard против зацикливания.
    onCoinImgError(event) {
      const img = event.target;
      if (!img || img.dataset.fallbackApplied) return;
      img.dataset.fallbackApplied = "1";
      img.src =
        "data:image/svg+xml;utf8," +
        encodeURIComponent(
          '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">' +
          '<circle cx="20" cy="20" r="20" fill="#2b2f36"/>' +
          '<circle cx="20" cy="20" r="12" fill="none" stroke="#8a90a0" stroke-width="2"/>' +
          '<text x="20" y="25" font-size="13" fill="#c9cdd6" text-anchor="middle" font-family="Arial">$</text>' +
          "</svg>",
        );
    },

    async fetchCoins() {
      // Цены проксируются нашим бэкендом (кэш 30с) — не бьём в CoinGecko
      // из браузера: один запрос на всех, без rate-limit и ключа в бандле.
      this.coinsLoading = true;
      try {
        const response = await axios.get(apiDomain + "/exchange/prices");
        this.coins = Array.isArray(response.data) ? response.data : [];
        this.tryApplyDraftCoin();
        // Прямой заход /buy/BUY/btc — coins загрузились после watcher'а,
        // тут же синхронизируем step + selectedCoin.
        this.syncStepFromRoute();
      } catch (error) {
        console.error("Error fetching coins:", error);
      } finally {
        this.coinsLoading = false;
      }
    },

    clearForm() {
      this.buyForm = {
        buyAmount: 0,
        transactionDoc: null,
        buyCount: 0,
        exType: this.buyForm.exType,
        digitalWalletId: 0,
        bankAccountId: 0,
        transactionId: "",
        currency: "USD",
        network: "", // ✅ reset
      };
      this.showErrors = false;
    },

    fetchBalances() {
      axios
        .get(apiDomain + "/funding/balances", { headers: getHeader() })
        .then((res) => { this.balances = Array.isArray(res.data) ? res.data : []; })
        .catch(() => { this.balances = []; });
    },
    sellMax() {
      // «Продать всё» — комиссия берётся сверху, поэтому продаём столько,
      // чтобы проданное + комиссия ровно уложились в остаток:
      //   base = available / (1 + fee_pct).
      const avail = Number(this.availableForSell) || 0;
      const feePct = this.commissionPercentDecimal || 0;
      const base = feePct >= 0 ? avail / (1 + feePct) : avail;
      // Округляем вниз до 8 знаков, чтобы из-за округления не превысить остаток.
      this.buyForm.buyAmount = Math.floor(base * 1e8) / 1e8;
      this.onAnyInput();
    },
    // Клик по кнопке создания. Если форма невалидна (незаполненные
    // поля, превышение баланса/лимита) — не отправляем ордер, только
    // подсвечиваем проблемные поля через showErrors. Отправка идёт
    // только при полностью валидной форме.
    onSubmitClick() {
      this.showErrors = true;
      if (!this.isFormComplete || this.isOverMonthlyLimit) return;
      this.createOrder();
    },
    fetchWallets() {
      axios
        .get(apiDomain + "/exchange/digitalwallet/list", { headers: getHeader() })
        .then((res) => {
          const all = Array.isArray(res.data) ? res.data : [];
          this.wallets = all.filter((w) => w.walletType === "Crypto");
          this.bankAccounts = all.filter((w) => w.walletType !== "Crypto");
        })
        .catch((e) => {
          console.error(e);
          this.$bvToast.toast("Не удалось загрузить список кошельков.", {
            variant: "danger",
            title: "Ошибка",
            autoHideDelay: 5000,
            toaster: "b-toaster-top-center",
            solid: true,
          });
        });
    },

    fetchIntervalOfCommissions() {
      axios
        .get(apiDomain + "/exchange/commission/list", { headers: getHeader() })
        .then((response) => {
          const data = Array.isArray(response.data) ? response.data : [];
          this.commissions = data;
        })
        .catch((error) => {
          console.error("Ошибка при загрузке интервалов комиссий!", error);
        });
    },

    fetchUserDetails() {
      if (!this.loginedUser || !this.loginedUser.id) return;
      axios
        .get(`${apiDomain}/exchange/userdetails/${this.loginedUser.id}`, { headers: getHeader() })
        .then((res) => {
          this.loadedUserData = res.data || {};
          // Аккаунт заморожен — торговля недоступна: уводим из формы сделки.
          const f = this.loadedUserData && this.loadedUserData.accountFrozen;
          if (f === 1 || f === "1" || f === true) {
            this.$bvToast && this.$bvToast.toast(
              "Аккаунт заморожен — операции покупки/продажи временно недоступны. Обратитесь в поддержку: support@payton.kz",
              { title: "Сервис недоступен", variant: "warning", toaster: "b-toaster-top-center", solid: true, autoHideDelay: 6000 }
            );
            this.$router.replace("/userwallet").catch(() => {});
          }
        })
        .catch((err) => console.error("Ошибка при загрузке данных пользователя:", err));
    },
  },

  mounted() {
    const exType = this.$route.params.exType;
    this.buyForm.exType = exType;
    // Restore BEFORE fetches that might overwrite buyForm — the
    // values are reapplied as soon as the draft is read; the coin
    // selection waits for fetchCoins().
    this.restoreDraftIfAny();
    this.fetchCoins();
    this.fetchWallets();
    this.fetchIntervalOfCommissions();
    this.fetchUserDetails();
    this.fetchAssetCatalog();
    this.fetchMonthlyLimit();
    this.fetchBalances();
  },

  watch: {
    "$route.params.exType"(newType) {
      this.buyForm.exType = newType;
      this.buyForm.digitalWalletId = 0;
      this.buyForm.bankAccountId = 0;
      this.buyForm.transactionId = "";
      this.buyForm.network = ""; // ✅ reset on switch
      this.showErrors = false;
      // Автоподбор дефолтной сети — иначе filteredWallets вернёт
      // все крипто-кошельки (network="", условие else-fallback).
      // setExType вызывает autoFill сам, но router.replace фаэрит
      // этот watcher уже ПОСЛЕ него и обнуляет сеть повторно.
      this.autoFillNetworkForSelected();
    },
    // URL-driven step: /buy/BUY (список) ↔ /buy/BUY/btc (форма).
    // Синхронизируем step и selectedCoin при любом изменении symbol
    // в роуте — включая browser back button.
    "$route.params.symbol"() {
      this.syncStepFromRoute();
    },
    // Auto-pick the default network whenever the coin selection
    // changes — keeps single-network assets (BTC/ETH/SOL) silent and
    // multi-network ones (USDT/USDC) on the default until the user
    // overrides. Also reset the input unit to USD: keeping "COIN" mode
    // across coin changes would silently rescale the typed number
    // (0.05 BTC vs 0.05 USDT are wildly different USD totals).
    "selectedCoin.symbol"() {
      this.autoFillNetworkForSelected();
      this.inputUnit = "USD";
      // Draft сбрасываем — при смене монеты он бессмыслен (0.05 BTC
      // и 0.05 USDT — совсем разные суммы). USD-value сохраняем.
      this.coinInputDraft = 0;
    },
  },
};
</script>

<style scoped>
/* your existing styles... */
.buy-page { padding-bottom: 24px; }
.title-badge{ width:44px;height:44px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;background:rgba(239,185,20,.08);border:1px solid rgba(239,185,20,.18);color:#efb914;}
.header-sub{ color:#9aa0ad;}
.help-card{ border-radius:16px;background:rgba(24,25,29,.6);border:1px solid rgba(119,126,144,.25);padding:14px;}
.help-ic{ width:34px;height:34px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:rgba(88,189,125,.1);border:1px solid rgba(88,189,125,.25);color:#58bd7d;}
.help-title{ color:#fcfcfd;font-weight:800;font-size:12px;letter-spacing:.04em;text-transform:uppercase;}
.help-text{ color:#b1b5c3;}
.right-out{ border-radius:16px;background:var(--Shade-2-30,#18191d);box-shadow:0px 64px 64px -48px rgba(15,15,15,.1);}
.coin-search{ width:320px;max-width:100%;}
.coin-search-inp{ border-radius:14px;border:1px solid rgba(119,126,144,.25);background:rgba(35,38,47,.4);overflow:hidden;}
.coin-search-inp :deep(input){ color:#fcfcfd;}
.coin-search-inp :deep(.input-group-text){ color:#b1b5c3;}
.crypto-row{ border-radius:16px;transition:transform .12s ease,background .12s ease,border .12s ease;border:1px solid rgba(119,126,144,.1);}
.crypto-row:hover{ cursor:pointer;transform:translateY(-1px);background:var(--Neutrals-2,#23262f);border:1px solid rgba(239,185,20,.22);}
.coin-card{ border-radius:16px;padding:14px 16px;background:rgba(35,38,47,.4);border:1px solid rgba(119,126,144,.18);}
.summary-card{ border-radius:16px;padding:14px 16px;background:rgba(35,38,47,.25);border:1px solid rgba(119,126,144,.18);}
.sum-big{ color:#fcfcfd;font-weight:800;font-size:22px;letter-spacing:-.02em;}
.sum-sub{ font-size:12px;}
.field-wrap{ position:relative;}
.field-hint{ margin-top:6px;font-size:12px;color:#ff6b6b;display:flex;align-items:center;}
.field-error :deep(input),
.field-error :deep(select),
.field-error input,
.field-error select{ border-color:rgba(255,107,107,.9)!important;box-shadow:0 0 0 3px rgba(255,107,107,.12);}
.select-dark{ background:transparent;border-radius:12px;border:2px solid var(--Neutrals-3,#353945);color:#fcfcfd;font-size:13px;}
.select-dark option{ background:#18191d;color:#fcfcfd;}
/* readonly variant — shows the only valid network without giving
   the impression it's selectable */
.select-dark--readonly{
  display:flex;align-items:center;cursor:default;color:#b1b5c3;
  background:rgba(53,57,69,.35);
}
.inline-error{ color:#ff6b6b;font-size:13px;font-weight:700;display:inline-flex;align-items:center;background:rgba(255,107,107,.08);border:1px solid rgba(255,107,107,.18);padding:8px 12px;border-radius:12px;}
.success-wrap{ padding:28px 10px 18px;}
.success-ic{ width:64px;height:64px;border-radius:22px;margin:0 auto;display:flex;align-items:center;justify-content:center;background:rgba(88,189,125,.1);border:1px solid rgba(88,189,125,.25);color:#58bd7d;}
.pct-up{ color:#58bd7d;}
.pct-down{ color:#ff6b6b;}
.fade-enter-active,.fade-leave-active{ transition:opacity .18s ease;}
.fade-enter,.fade-leave-to{ opacity:0;}
.cancel-btn{ border-radius:12px;border:2px solid var(--Neutrals-4,#777e90);transition:transform .12s ease,border-color .12s ease;}
.cancel-btn:hover{ transform:translateY(-1px);border-color:rgba(239,185,20,.35);}
.reg-btn{ border-radius:14px;background:rgba(239,185,20,.12);border:1px solid rgba(239,185,20,.35);cursor:pointer;transition:transform .12s ease,background .12s ease;}
.reg-btn:hover{ transform:translateY(-1px);background:rgba(239,185,20,.18);}
.reg-btn-disabled{ opacity:.55;cursor:not-allowed;filter:grayscale(.2);}
.list-sep{ height:1px;background:rgba(119,126,144,.25);}
.coins-loading{ display:flex;align-items:center;justify-content:center;gap:12px;padding:48px 0;color:#b1b5c3; }
.coins-spinner{ width:26px;height:26px;color:#efb914; }
.coins-loading-text{ font-size:14px; }
.step-item-step{ width:1px;height:24px;border-right:1px dashed #777e90;}
.step-number{ width:33px;height:33px;padding:7px 10px;color:var(--Neutrals-4,#777e90);text-align:center;font-family:Inter;font-size:14px;font-weight:700;line-height:16px;border-radius:36px;border:2px solid var(--Neutrals-3,#353945);}
.step-name{ color:var(--Neutrals-4,#777e90);font-family:Inter;font-size:14px;font-weight:700;line-height:16px;}
.step-item-active .step-name{ color:#fcfcfd;}
.crypto-main-title{ color:var(--Neutrals-8,#fcfcfd);font-family:Inter;font-size:48px;font-weight:700;line-height:56px;letter-spacing:-.96px;text-wrap:balance;}
.crypto-action-title{ color:var(--Neutrals-8,#fcfcfd);font-family:Inter;font-size:24px;font-weight:700;line-height:32px;}
.payton-desc{ color:var(--Neutrals-4,#777e90);font-family:Inter;font-size:12px;font-weight:500;line-height:20px;}
.payton-link{ color:var(--Neutrals-6,#e6e8ec);font-family:Inter;font-size:12px;font-weight:500;line-height:20px;}
.reg-label{ color:var(--Neutrals-5,#b1b5c3);font-family:Inter;font-size:12px;font-weight:700;line-height:12px;text-transform:uppercase;}
.unit-switch{ display:inline-flex;background:rgba(53,57,69,.45);border:1px solid rgba(119,126,144,.25);border-radius:999px;padding:2px;gap:2px;}
.unit-chip{ font:700 11px/1 Inter;color:#b1b5c3;background:transparent;border:0;padding:5px 10px;border-radius:999px;cursor:pointer;letter-spacing:.02em;text-transform:uppercase;}
.unit-chip:hover{ color:#fcfcfd;}
.unit-chip.is-active{ background:#efb914;color:#1a1d22;}

/* BUY/SELL toggle — крупнее USD/COIN toggle, потому что это верхнее
   логическое разделение (что вообще делает клиент). Buy зелёный,
   Sell красноватый — привычная цветовая семантика бирж. */
.direction-switch {
  display: inline-flex;
  background: rgba(53,57,69,.55);
  border: 1px solid rgba(119,126,144,.25);
  border-radius: 12px;
  padding: 3px;
  gap: 3px;
}
.dir-chip {
  font: 700 13px/1 Inter;
  color: #b1b5c3;
  background: transparent;
  border: 0;
  padding: 9px 22px;
  border-radius: 10px;
  cursor: pointer;
  letter-spacing: .02em;
  transition: all .15s;
}
.dir-chip:hover { color: #fcfcfd; }
.dir-chip-active-buy  { background: #10b981; color: #0a0f0d; }
.dir-chip-active-sell { background: #ef4444; color: #fdf5f5; }
.wallet-empty{ border-radius:16px;padding:14px 16px;background:rgba(239,185,20,.08);border:1px solid rgba(239,185,20,.35);}
.wallet-empty-ic{ width:36px;height:36px;border-radius:12px;background:rgba(239,185,20,.18);color:#efb914;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;}
.wallet-empty-title{ color:#fcfcfd;font:700 14px/20px Inter;}
.wallet-empty-body{ color:#b1b5c3;font:500 12px/18px Inter;}
.wallet-empty-cta{ font:700 12px/16px Inter;color:#1a1d22;background:#efb914;border:0;border-radius:999px;padding:9px 16px;cursor:pointer;letter-spacing:.02em;text-transform:uppercase;}
.wallet-empty-cta:hover{ filter:brightness(1.05);}
.fee-disclaimer{ display:block;color:#777e90;font:500 11px/16px Inter;margin-top:4px;}
.fee-final-note{ display:flex;align-items:flex-start;gap:8px;padding:10px 14px;border-radius:12px;background:rgba(56,114,224,.08);border:1px solid rgba(56,114,224,.28);color:#b1b5c3;font:500 12px/18px Inter;}
.fee-final-note .b-icon{ color:#3872e0;flex-shrink:0;margin-top:1px;}
.reg-input{ color:var(--Neutrals-6,#e6e8ec);font-family:Inter;font-size:14px;font-weight:500;line-height:24px;appearance:none;background-color:transparent;border:none;outline:none;border-radius:12px;border:2px solid var(--Neutrals-3,#353945);}
.reg-input:focus{ border-color:rgba(239,185,20,.5);box-shadow:0 0 0 3px rgba(239,185,20,.12);}
.info-left{ color:var(--Neutrals-4,#777e90);font-family:Inter;font-size:16px;font-weight:400;line-height:24px;}
.coin-sum{ color:var(--Neutrals-8,#fcfcfd);text-align:right;font-family:Inter;font-size:16px;font-weight:500;line-height:24px;}
.cancel-btn-text{ color:var(--Neutrals-8,#fcfcfd);text-align:center;font-family:Inter;font-size:14px;font-weight:700;line-height:16px;}
.no-style{ text-decoration:none;}
.min-w-0{ min-width:0;}
.text-truncate{ overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.list-header-text{ color:#9aa0ad;font-weight:700;text-transform:uppercase;font-size:12px;letter-spacing:.04em;}
.list-text-number{ color:#b1b5c3;font-weight:700;}
.list-text-crypto{ color:#fcfcfd;font-weight:800;}
.list-text-code{ color:#777e90;font-weight:700;}
.list-text-price{ color:#fcfcfd;font-weight:800;}
.list-text-percentage{ font-weight:800;}
.coin-ic{ width:42px;height:42px;border-radius:16px;display:inline-flex;align-items:center;justify-content:center;background:rgba(35,38,47,.4);border:1px solid rgba(119,126,144,.18);}

.muted-mini { color:#9aa0ad; font-size:12px; }
.text-strong { color:#fcfcfd; font-weight:800; }
.sell-balance-line { display:flex; align-items:center; justify-content:space-between; gap:12px; }
.sell-max-link { color:#efb914; font-size:12px; font-weight:700; white-space:nowrap; }
.sell-max-link:hover { text-decoration:underline; }
.mono{ font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace; }

.broker-mini-card{
  border-radius:16px;
  padding:14px;
  background:rgba(35,38,47,.42);
  border:1px solid rgba(239,185,20,.22);
  box-shadow:0px 18px 40px -28px rgba(239,185,20,.22);
}
.broker-ic{
  width:34px;height:34px;border-radius:12px;
  display:inline-flex;align-items:center;justify-content:center;
  background:rgba(239,185,20,.10);
  border:1px solid rgba(239,185,20,.22);
  color:#efb914;
}
.broker-title{ color:#fcfcfd;font-weight:800;font-size:13px;letter-spacing:.02em; }
.broker-sub{ color:#b1b5c3; }
.broker-badge{
  display:inline-flex;align-items:center;
  font-size:12px;font-weight:800;padding:6px 10px;border-radius:999px;
  color:#58bd7d;background:rgba(88,189,125,.10);border:1px solid rgba(88,189,125,.22);
}
.broker-wallet-box{
  padding:12px;
  border-radius:14px;
  border:1px solid rgba(119,126,144,.18);
  background:rgba(24,25,29,.55);
}
.broker-k{
  color:#9aa0ad;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;
}
.broker-v{ color:#fcfcfd;font-weight:800;font-size:13px; }
.broker-mini-grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap:10px;
}
.broker-mini-item{
  padding:10px 12px;border-radius:14px;
  border:1px solid rgba(119,126,144,.18);
  background:rgba(24,25,29,.45);
}
.btn-soft{
  border-radius:12px;
  border:1px solid rgba(119,126,144,.25);
  background:rgba(24,25,29,.35);
}
.limit-banner{
  color:#ffdfdf;
  font-size:13px;
  font-weight:800;
  display:flex;
  align-items:center;
  background:rgba(255,107,107,.10);
  border:1px solid rgba(255,107,107,.22);
  padding:10px 12px;
  border-radius:14px;
}
</style>
